import { useState, useEffect } from 'react';
import { reportStepsAPI } from '../../services/api';
import i18n from '../../i18n';

export interface ReportCard {
  name: string;
  query_suggestion: string;
  index: number;
  status: string;
}

export interface UserTask {
  task_id: string;
  created_at: string;
  file_name: string;
  status: string;
  message: string;
  reports_count: number;
  pending_reports: number;
  report_cards: ReportCard[];
}

export const useUserTasks = (limit: number = 10) => {
  const [tasks, setTasks] = useState<UserTask[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const loadUserTasks = async () => {
    try {
      setIsLoading(true);
      setError(null);

      const response = await reportStepsAPI.getUserTasks(limit);
      setTasks(response.data);
    } catch (err: any) {
      console.error('Ошибка при загрузке задач пользователя:', err);
      setError(err.response?.data?.detail || i18n.t('common:error'));
    } finally {
      setIsLoading(false);
    }
  };

  const deleteTask = async (taskId: string) => {
    await reportStepsAPI.deleteUserTask(taskId);
    setTasks(prev => prev.filter(t => t.task_id !== taskId));
  };

  useEffect(() => {
    loadUserTasks();
  }, []);

  return {
    tasks,
    isLoading,
    error,
    refreshTasks: loadUserTasks,
    deleteTask
  };
};
